/**
 * Stats collection: play-once sequenced reveal (fade left → mid → right + travelling icon).
 * Add class stats-eq on the block root. CSS owns the keyframes.
 */
(function () {
	const SELECTOR = '.stats-eq';
	const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
	let observer;

	function reducedMotion() {
		return motionQuery.matches;
	}

	const LEFT_IN = 0.08297;
	const RIGHT_IN = 0.73874;

	function durationMs(el) {
		const raw = window.getComputedStyle(el).getPropertyValue('--stats-eq-duration').trim();
		const n = parseFloat(raw);

		if (!Number.isFinite(n)) {
			return 6026;
		}

		return /ms$/i.test(raw) ? n : n * 1000;
	}

	function startCounters(el) {
		const start = window.startAnimatedCounter;

		if (typeof start !== 'function') {
			return;
		}

		const left = el.querySelectorAll('.stats-eq__left .animated-counter');
		const right = el.querySelectorAll('.stats-eq__right .animated-counter');

		if (reducedMotion()) {
			left.forEach(start);
			right.forEach(start);
			return;
		}

		const duration = durationMs(el);

		window.setTimeout(function () {
			left.forEach(start);
		}, duration * LEFT_IN);

		window.setTimeout(function () {
			right.forEach(start);
		}, duration * RIGHT_IN);
	}

	function show(el) {
		el.classList.add('is-in');
		startCounters(el);
	}

	function prepare(el) {
		if (el.classList.contains('is-stats-eq-bound')) {
			return;
		}

		el.classList.add('is-stats-eq-bound');

		if (reducedMotion()) {
			show(el);
			return;
		}

		el.classList.add('is-stats-eq-ready');

		if (!observer) {
			observer = new IntersectionObserver(
				function (entries) {
					entries.forEach(function (entry) {
						if (!entry.isIntersecting) {
							return;
						}

						show(entry.target);
						observer.unobserve(entry.target);
					});
				},
				{ threshold: 0.25, rootMargin: '0px 0px -8% 0px' },
			);
		}

		observer.observe(el);
	}

	function inEditor() {
		return !!(
			document.body.classList.contains('block-editor-iframe__body') ||
			document.body.classList.contains('wp-admin') ||
			document.querySelector('.editor-styles-wrapper')
		);
	}

	function run() {
		if (inEditor()) {
			return;
		}

		document.querySelectorAll(SELECTOR).forEach(prepare);
	}

	window.runStatsEq = run;

	if (typeof motionQuery.addEventListener === 'function') {
		motionQuery.addEventListener('change', function (event) {
			if (event.matches) {
				document.querySelectorAll(SELECTOR).forEach(show);
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}
})();
